import { z } from "zod";

export interface BirthDateFields {
  month?: string;
  day?: string;
  year?: string;
}

export const childFormSchema = z.object({
  name: z.string().min(2, "Name must be at least 2 characters"),
  birthDate: z.object({
    month: z.string().optional(),
    day: z.string().optional(),
    year: z.string().optional()
  }).refine((data) => {
    // Only validate if all fields are present
    if (!data.month || !data.day || !data.year) return true;
    const date = new Date(
      Number(data.year),
      Number(data.month) - 1,
      Number(data.day),
      12, // Set to noon to avoid timezone issues
      0,
      0,
      0
    );
    return date <= new Date() && date >= new Date(1900, 0, 1, 12, 0, 0, 0);
  }, "Please enter a valid birth date")
});

export type ChildFormData = z.infer<typeof childFormSchema>;